import { defineMessages } from 'react-intl';

const translations = {
  breadcrumb: {
    handlingLists: {
      id: 'pages.handlingListView.breadcrumb.handlingLists',
      defaultMessage: 'Handling lists',
      description: 'label of the handling lists breadcrumb',
    },
  },
  subNavigation: {
    details: {
      id: 'pages.handlingListView.subNavigation.details',
      defaultMessage: 'Details',
      description: 'label of the details tab on the handling list view page',
    },
    items: {
      id: 'pages.handlingListView.subNavigation.items',
      defaultMessage: 'Items',
      description: 'label of the items tab on the handing list view page',
    },
    logs: {
      id: 'pages.handlingListView.subNavigation.logs',
      defaultMessage: 'Logs',
      description: 'label of the logs tab on the handing list view page',
    },
  },
  secondaryActions: {
    deleteHandlingList: {
      id: 'actions.delete',
      defaultMessage: 'Delete',
      description: 'label of the delete action',
    },
  },
  actions: {
    pick: {
      id: 'pages.handlingListView.actions.pick',
      defaultMessage: 'Pick',
      description: 'label of the pick button',
    },
    place: {
      id: 'pages.handlingListView.actions.place',
      defaultMessage: 'Place',
      description: 'label of the place button',
    },
  },
  deleteHandlingListDialog: {
    title: {
      id: 'deleteHandlingListDialog.title',
      defaultMessage: 'Delete handling list',
      description: 'Title of the delete handling list dialog',
    },
    description: {
      id: 'deleteHandlingListDialog.description',
      defaultMessage: 'Are you sure you would like to delete the handling list?',
      description: 'Description of the delete handling list dialog',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel action of the delete handling list dialog',
      },
      delete: {
        id: 'actions.delete',
        defaultMessage: 'Delete',
        description: 'Label of the delete action of the delete handling list dialog',
      },
    },
  },
  feedback: {
    handlingListDeleted: {
      id: 'pages.handlingListView.feedback.handlingListDeleted',
      defaultMessage: 'Handling list deleted',
      description: 'Success message of the handling list delete action',
    },
    handlingListNotDeleted: {
      id: 'pages.handlingListView.feedback.handlingListNotDeleted',
      defaultMessage: 'Handling list not deleted',
      description: 'Error message of the handling list delete action',
    },
  },
};

export default defineMessages(translations);
